import * as React from 'react';
import RunSheetDetails from './RunSheetUpdate';
import RescheduleDetails from './Reschedule';
import { CheckPermissions } from './Shared';
import { useNavigate } from 'react-router-dom';

const RunSheetData = () => {
    let navigate = useNavigate();
    const [tab, setTab] = React.useState("RunSheet");
    const [idList, setIdList] = React.useState<number[]>([]);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        window.scrollTo(0, 0);
        getData();
    }, []);

    const getData = async () => {
        var hasPermission = await CheckPermissions("ViewRunSheetUpdates");
        if (hasPermission) {
            setLoading(false);
        } else {
            navigate("/accessdenied");
        }
    }

    const goReschedule = (data: any) => {
        setTab("Reschedule");
        setIdList(data.idList);
    }

    const goRunSheet = () => {
        setTab("RunSheet");
    }
    
    var innerContents;
    if (tab == "RunSheet") {
        innerContents = <RunSheetDetails saveReschedule={goReschedule} />
    }
    else if (tab == "Reschedule") {
        innerContents = <RescheduleDetails idList={idList} save={goRunSheet} />
    }

    const renderDetails = (
        <div>
            <div className="tabsComponent" id="tab-container">
                <div>
                    {innerContents}
                </div>
            </div>

        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (
        <div>
            {contents}
        </div>
    );

};

export default RunSheetData;